<template>
    <div
        class="icon-wrapper"
        :title="props.title"
        :aria-hidden="props.ariaHidden || undefined"
        :style="{ backgroundColor: props.backgroundColour }"
    >
        <div class="type-icon" :class="`icofont-${props.icon.replace('icofont-', '')} ${props.size}`" :style="{ color: props.iconColour }" />
    </div>
</template>

<script lang="ts" setup>

const props = withDefaults(defineProps<{
    icon: string;
    backgroundColour?: string;
    iconColour?: string;
    size?: 'super-large' | 'extra-large' | 'large' | 'medium-large' | 'medium' | 'default' | 'small' | 'extra-small';
    title?: string;
    ariaHidden?: boolean;
}>(), {
    size: 'default',
    backgroundColour: 'transparent',
    iconColour: 'var(--primaryFont)',
    title: '',
    ariaHidden: false,
});

</script>

<style lang="scss" scoped>

.icon-wrapper {
    border-radius: var(--borderRadiusOuter);
    height: fit-content;
    width: fit-content;
    padding: var(--smallSpacing);

    .type-icon {
        &.super-large {
            font-size: var(--superLargeFontSize);
        }

        &.extra-large {
            font-size: var(--extraLargeFontSize);
        }

        &.large {
            font-size: var(--largeFontSize);
        }

        &.medium-large {
            font-size: var(--mediumLargeFontSize);
        }

        &.medium {
            font-size: var(--mediumFontSize);
        }

        &.default {
            font-size: var(--defaultFontSize);
        }

        &.small {
            font-size: var(--smallFontSize);
        }

        &.extra-small {
            font-size: var(--extraSmallFontSize);
        }
    }
}

</style>
